import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  margin-bottom: 48px;\n  @media (max-width: 768px) {\n    margin-bottom: 24px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Title } from "@/components/Product/Handout";
import { SectionWithDivider } from "@/components/Product/Handout/SectionWithDivider";
import styled from "styled-components";
import { AdBannerList, useAdBannerQuery } from ".";
export const HandoutAdBanner = (param)=>{
    let { shape ="default" , position ="productDetail" , subject  } = param;
    const { adBannerResponse , noAdItems  } = useAdBannerQuery({
        position,
        subject
    });
    if (noAdItems) return null;
    return /*#__PURE__*/ _jsx(SectionWithDivider, {
        children: /*#__PURE__*/ _jsxs(Stack, {
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    children: "쏠북 소식"
                }),
                /*#__PURE__*/ _jsx(AdBannerList, {
                    position: position,
                    children: adBannerResponse.items.map((param)=>/*#__PURE__*/ {
                        let { link , imageUrl , imageUrlPc , imageUrlTablet , imageUrlMobile , id  } = param;
                        return _jsx(AdBannerList.Item, {
                            link: link,
                            imageUrl: imageUrl,
                            imageUrlPc: imageUrlPc,
                            imageUrlTablet: imageUrlTablet,
                            imageUrlMobile: imageUrlMobile,
                            shape: shape,
                            id: id,
                            mixpanelPosition: "product detail page"
                        }, "adbanner-" + id);
                    })
                })
            ]
        })
    });
};
const Stack = styled.div.withConfig({
    componentId: "sc-661f6c27-0"
})(_templateObject());
